/**
 * An ISO timestamp as a day, its short month and its time in the reader's zone:
 * "25 oct., 13:43" in French, "Oct 25, 01:43 PM" in English. The spelling of a
 * moment in a journal, a journey or a deadline.
 *
 * Empty or unparseable input returns '' so callers drop the moment rather than
 * print a value nobody can read.
 */
export function formatDayTime(iso: string | null | undefined, locale: string | undefined): string {
  if (!iso) return '';

  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
